"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PaginationResultsBlock_1 = __importDefault(require("@Components/PaginationResultsBlock"));
const react_1 = __importStar(require("react"));
const PaginationAndLimit_1 = __importDefault(require("@Components/PaginationAndLimit"));
const mobx_react_1 = require("mobx-react");
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const SongwriterCatalogBuilderResults = (props) => {
    const { setLoading, songwriterWriterSearchStore, children } = props;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { songwriterStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const count = songwriterWriterSearchStore.totalNumberOfResults;
    const onPageChange = (pagination) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield songwriterWriterSearchStore.searchForParties(pagination).finally(() => setLoading(false));
    });
    const onLimitChange = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield songwriterWriterSearchStore.setCurrentResultsPerPageLimit(newLimit).finally(() => setLoading(false));
    });
    return songwriterWriterSearchStore.hasSearched ? (count > 0 ? (react_1.default.createElement("div", { className: 'writer-search-results' },
        react_1.default.createElement(PaginationResultsBlock_1.default, { totalResults: count, workNumTitles: songwriterWriterSearchStore.numTitles, justResults: false, hideNoResults: true }),
        children,
        react_1.default.createElement(Button_1.Button, { className: 'catalog-button-link', mainColor: true, type: 'primary', onClick: () => navigate(navigation_1.default.songwriter.catalog.root(songwriterStore.currentSongwriterId)) }, "View my catalog"),
        react_1.default.createElement(PaginationAndLimit_1.default, { paginationInfo: songwriterWriterSearchStore.publicSearchByPartyCriteriaPaginationInfo, onPageChange: onPageChange, onLimitChange: onLimitChange, count: count, limit: songwriterWriterSearchStore.currentPartyResultsPerPageLimit }))) : (react_1.default.createElement(react_1.default.Fragment, null, "No Results Found"))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = (0, mobx_react_1.observer)(SongwriterCatalogBuilderResults);
